import { Injectable } from '@angular/core';
import { BaseWrapperService } from '../../shared/base-service/base-wrapper.service';

@Injectable()
export class AAMVAIntegrationService extends BaseWrapperService {

    /**
     * updates the nmvtis messages state
     * @param businessTransactionId: Business transaction id.
     * @param integrationInteractionMessageTypeId: Interaction message state type
     * @param interactionMessageStateTypeId: Interaction message state type
     * @return True if the call succeeded.  Otherwise, false.
     */
    updateNmvtisInteractionMessageState = (businessTransactionNumberId: number, interactionMessageId: number, interactionMessageStateTypeId: number) => this.post('TitleRegistration/Nmvtis/' + businessTransactionNumberId + '/InteractionMessage/' + interactionMessageId + '/State/' + interactionMessageStateTypeId, null);

    /**
     * Ask AAMVA integration to resend previous interaction message for UsedVehicleInquiryResponse (NM04)
     * @param businessTransactionId: Business transaction id.
     * @return True if the call succeeded.  Otherwise, false.
     */
    resendNmvtisInteractionMessage = (businessTransactionNumberId: number) => this.get('TitleRegistration/Nmvtis/' + businessTransactionNumberId + '/InteractionMessage/Resend');

    /**
     * Ask AAMVA integration to resend previous interaction message for UsedVehicleInquiryResponse (NM04)
     * @param businessTransactionId: Business transaction id.
     * @return True if the call succeeded.  Otherwise, false.
     */
    getNmvtisInteractionMessageById = (businessTransactionNumberId: number, interactionMessageId: number) => this.get('TitleRegistration/Nmvtis/' + businessTransactionNumberId + '/InteractionMessage/' + interactionMessageId);

    startNmvtisTransactionForHold = (businessTransactionNumberId: number, businessTransactionTypeId: number) => this.get('TitleRegistration/Nmvtis/HoldTransaction/' + businessTransactionNumberId + '/Type/' + businessTransactionTypeId);

    /**
    * Gets the psvr by vin.
    * @param vin: VIN.
    * @param status: Status of the PSVR: InProgress or Completed.
    */
    getPsvrByVin = (vin: string, status: number) => this.get('TitleRegistration/Nmvtis/Psvr/VIN/' + vin + '/Status/' + status);

    /* getPsvrByBusinessTransaction = (businessTransactionNumberId: number) => {
        return this.get('TitleRegistration/Nmvtis/Psvr/BusinessTransactionNumber/' + businessTransactionNumberId);
    }*/
    /**
     * Gets the maping of findingTypes to the actionTypes
     * @return True if the call succeeded. Otherwise, false.
     */
    getPsvrFindingActionTakenMap = () => this.get('TitleRegistration/Nmvtis/Psvr/FindingActionTakenReportStatusTypeMap');

    savePsvr = (psvr: any) => this.post('TitleRegistration/Nmvtis/Psvr/', psvr);

}
